import { createFileRoute } from "@tanstack/react-router";
import { LoginCard } from "@/projects/components/login-card";

export const Route = createFileRoute("/login/admin")({
  head: () => ({ meta: [{ title: "Admin Login — રાજનગર જ્ઞાનોત્સવ 2.0" }] }),
  component: () => <LoginCard role="admin" />,
});
